import _ from "lodash";
import React, { Component } from "react";
import UsersFormView from "./users-form-view";
import { requestAddUser } from "./users-form-actions";
import {
  showError,
  clearError,
  showSuccess
} from "../../snackbars/snackbars-actions";

import { connect } from "react-redux";
import Utils from "../../../library/utils";

const INITIAL_STATE = {
  email: "",
  billing: false,
  booking: false,
  userManagement: false
};

class UserListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE
    };
  }

  _onPermissionToggle = key => {
    this.setState({ [key]: true });
  };

  _onChangeEmail = e => {
    this.setState({ email: e.target.value });
  };

  _onFormAddPress = () => {
    if (this.isFormValid()) {
      const { email, billing, booking, userManagement } = this.state;
      const payload = {
        email,
        userManagement,
        billing,
        booking,
        asBusinessId: this.props.auth.business_id
      };

      this.props.requestAddUser(payload, success => {
        this.setState(INITIAL_STATE);
        if (success) {
          this._showSuccess("User added successfully");
        }
      });
    }
  };

  _showError = text => {
    this.props.showError(text);
  };

  _showSuccess = text => {
    this.props.showSuccess(text);
  };

  isFormValid = () => {
    const { email } = this.state;
    if (_.isEmpty(email)) {
      this._showError("Email is required!");
      return false;
    } else if (!Utils.isValidEmail(email)) {
      this._showError("Invalid email");
      return false;
    }
    return true;
  };

  render() {
    return (
      <UsersFormView
        {...this.props}
        {...this.state}
        onPermissionToggle={this._onPermissionToggle}
        onChangeEmail={this._onChangeEmail}
        onAddPress={this._onFormAddPress}
      />
    );
  }
}

const mapStateToProps = state => ({
  usersAndPermissions: state.usersAndPermissions,
  auth: state.auth
});

const mapDispatchToProps = {
  requestAddUser: requestAddUser,
  clearError: clearError,
  showError: showError,
  showSuccess: showSuccess
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserListing);



// WEBPACK FOOTER //
// ./src/components/users-and-permissions/users-form/users-form.js